import React from 'react';

import { useItineraryContext } from '@/context/ItineraryContext';

import { StyledNavContent, StyledNavContainer, StyledNavItem, StyledLogoWrapper, StyledArrowTail } from './styles';

import type { NavbarVariant } from './styles';

interface NavbarProps {
  variant?: NavbarVariant;
}

export function TopNavbar({ variant = 'primary' }: NavbarProps) {
  const { navigation } = useItineraryContext();
  return (
    <StyledNavContainer $variant={variant}>
      <StyledNavContent>
        <StyledLogoWrapper>
          <img src={variant === 'primary' ? '/white_wrapped.png' : '/black_wrapped.png'} alt="logo" />
          {/* <img src={variant === 'primary' ? '/white_standard.png' : '/black_standard.png'} alt="logo" /> */}
        </StyledLogoWrapper>

        {navigation.itineraryNavigationItems.map((item, index) => (
          <React.Fragment key={item.key}>
            <StyledNavItem
              onClick={() => navigation.to(item.key)}
              $variant={variant}
              $active={navigation.currentPage?.path === item.path}
            >{`${index + 1}. ${item.name}`}</StyledNavItem>
            {/* {index !== navigation.navigationItems.length - 1 && <StyledArrowTail> &gt; </StyledArrowTail>} */}
            {index! < 5 && <StyledArrowTail $variant={variant}> &gt; </StyledArrowTail>}
          </React.Fragment>
        ))}
      </StyledNavContent>
    </StyledNavContainer>
  );
}
